import React, { useState } from "react";
import DataTable from "../../UI/table/DataTable";
import { useQuery } from "react-query";
import { getCurios } from "../../../MyApi/curior";
import { curiorColumns } from "../../../pages/shipping/shippingdata";
import { useNavigate } from "react-router-dom";

const CuriorDeliveryCompany = ({id}) => {
    const [currentPage,setCurrentPage]=useState(1)
    const navigate =useNavigate()
  const { data: curiorsData ,isLoading } = useQuery(["getCurios",id], ()=>getCurios(id));
  const curiors = curiorsData?.data?.couiers || [];
  const totalCuriorItems = curiorsData?.data?.pagination?.total || 0;
  const lastCuriorPage = curiorsData?.data?.pagination?.last_page || 0;
   

 const handleNavigate =()=>{
  navigate(`${process.env.PUBLIC_URL}/shipping/store-curior?store_id=${id}`);
 }

  return (  
    <div>
      <DataTable
        columns={curiorColumns}
        data={curiors}
        title={"السائقين"}
        actionLabel={"إضافة سائق جديد"}
        emptyMessage="لا توجد بيانات للسائقين "
        onAddClick={handleNavigate}
       createPermission={"create_couier"}
        itemsPerPage={lastCuriorPage}
        totalItems={totalCuriorItems}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CuriorDeliveryCompany;
